import { getTenantAssessmentPaths, useWorkspace } from "@sg-protect/shell";
import { Navigate } from "react-router";
import { usePaths } from "../../paths.ts";

export function HomeEntryRedirect() {
    const currentWorkspace = useWorkspace();
    const paths = usePaths();

    if (currentWorkspace.isPartner) {
        return <Navigate to={paths.partnerDashboard} replace />;
    }

    return <Navigate to={getTenantAssessmentPaths(currentWorkspace.id).home} replace />;
}
